import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import listBizImg from "../../../assets/images/homepage/Images/List your business photo.jpg";
import communityImg from "../../../assets/images/homepage/Images/community day.jpg";
import baselImg from "../../../assets/images/homepage/Images/JackedRabbit Basel ad.jpg";
import ruleturfImg from "../../../assets/images/homepage/Images/ruleturf (1).png";

import { submitPartnerLeadCall } from "../../../api/apiOperations";

import {
  Container,
  Inner,
  LeftSide,
  ImageCollage,
  CollageImg,
  FormCard,
  FormTitle,
  FormSubtitle,
  FieldRow,
  FieldFull,
  Input,
  Select,
  SubmitButton,
  RightSide,
  RightHeading,
  RightText,
} from "./styles";

const LOCATION_OPTIONS = ["1", "2–5", "6–10", "10+"];

const formatPhone = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const ContactUsSection = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [locationCount, setLocationCount] = useState("");
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);

  const isValid = email && phone.replace(/\D/g, "").length >= 10 && name && businessName && zipCode && locationCount;

  const handleSubmit = async () => {
    if (!isValid) return;
    setLoading(true);
    try {
      await submitPartnerLeadCall({
        name,
        businessName,
        email,
        phone: phone.replace(/\D/g, ""),
        zipCode,
        locationCount,
        website: website || undefined,
        source: "homepage",
      });
      navigate("/signup_new_partner/list?submitted=true");
    } catch (_) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container id="become-a-partner">
      <Inner>
        <LeftSide>
          <ImageCollage>
            <CollageImg pos="tl" src={baselImg} alt="JackedRabbit event" />
            <CollageImg pos="tr" src={listBizImg} alt="List your business" />
            <CollageImg pos="bl" src={communityImg} alt="Community" />
            <CollageImg pos="br" src={ruleturfImg} alt="Training" />
          </ImageCollage>

          <FormCard>
            <FormTitle>Learn more</FormTitle>
            <FormSubtitle>See what JackedRabbit can do for your business</FormSubtitle>
            <FieldFull>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FieldFull>
            <FieldFull>
              <Input
                type="tel"
                placeholder="Phone"
                value={phone}
                onChange={(e) => setPhone(formatPhone(e.target.value))}
              />
            </FieldFull>
            <FieldFull>
              <Input
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FieldFull>
            <FieldFull>
              <Input
                placeholder="Business name"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
              />
            </FieldFull>
            <FieldRow>
              <Input
                placeholder="Zip code"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
              <Select
                value={locationCount}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setLocationCount(e.target.value)}
              >
                <option value="" disabled># of locations</option>
                {LOCATION_OPTIONS.map((o) => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </Select>
            </FieldRow>
            <FieldFull>
              <Input
                placeholder="Website (optional)"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
            </FieldFull>
            <SubmitButton onClick={handleSubmit} disabled={!isValid || loading}>
              {loading ? "Sending..." : "Get in touch →"}
            </SubmitButton>
          </FormCard>
        </LeftSide>

        <RightSide>
          <RightHeading>
            You focus on the experience.<br />We bring you commited leads.
          </RightHeading>
          <RightText>
            Our trials are designed to convert. By limiting users to a single location for the month,
            we give you real time to build relationships that turn trials into long-term members.
          </RightText>
        </RightSide>
      </Inner>
    </Container>
  );
};

export default ContactUsSection;
